import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const credentials = [{
  icon: '🔥',
  title: 'Salí de las adicciones',
  desc: 'Estuve dopaminado 24/7 — redes, distracciones, placer inmediato. Aprendí a romper ese ciclo desde adentro.'
}, {
  icon: '🧠',
  title: 'Entrené mi mentalidad',
  desc: 'No leí teoría. La viví, la rompí y la reconstruí. Hoy uso mi mente como herramienta, no como enemigo.'
}, {
  icon: '🎯',
  title: 'Construí disciplina real',
  desc: 'La misma disciplina que me enseño a escalar metas — dinero, habilidades, identidad — te la paso a vos.'
}];
export function MentorSection() {
  return <section className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-133">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[400px] h-[400px] bg-[#C9A84C]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-134" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-135">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-136">
          <span className="text-[#C9A84C] tracking-[0.2em] text-xs font-bold uppercase mb-3 block" data-id="element-137">
            Tu mentor
          </span>
          <h2 className="text-4xl md:text-5xl font-['Bebas_Neue'] text-white" data-id="element-138">
            QUIÉN TE DA LA MENTORÍA
          </h2>
          <div className="w-12 h-[1px] bg-[#C9A84C] mx-auto mt-4" data-id="element-139" />
        </motion.div>

        {/* Main card */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-140">
          {/* Avatar side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="flex flex-col items-center md:items-start gap-6" data-id="element-141">
            {/* Avatar */}
            <div className="relative" data-id="element-142">
              <div className="w-40 h-40 rounded-full border-2 border-[#C9A84C] overflow-hidden shadow-[0_0_40px_rgba(201,168,76,0.2)]" data-id="element-143">
                <img src="https://i.ibb.co/W4vpwrGp/Whats-App-Image-2026-02-20-at-3-51-33-PM-1.jpg" alt="Manu Delacruz" className="w-full h-full object-cover object-top" data-id="element-144" />
              </div>
              {/* Online indicator */}
              <div className="absolute bottom-3 right-3 w-5 h-5 rounded-full bg-emerald-500 border-2 border-[#0a0a0a]" data-id="element-145" />
            </div>

            {/* Name & title */}
            <div className="text-center md:text-left" data-id="element-146">
              <h3 className="font-['Bebas_Neue'] text-4xl text-white tracking-wide leading-none" data-id="element-147">
                MANU DELACRUZ
              </h3>
              <p className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase mt-1" data-id="element-148">
                Mentor de Disciplina & Mentalidad
              </p>
            </div>

            {/* Quote */}
            <blockquote className="border-l-2 border-[#C9A84C] pl-4 text-gray-400 text-sm italic leading-relaxed max-w-xs text-left" data-id="element-149">
              "No te enseño teoría. Te enseño lo que yo viví, rompí y
              reconstruí."
            </blockquote>
          </motion.div>

          {/* Credentials side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="flex flex-col gap-5" data-id="element-150">
            {/* Bio */}
            <p className="text-gray-300 leading-relaxed text-base" data-id="element-151">
              Logré salir de las adicciones y de estar{' '}
              <span className="text-white font-semibold" data-id="element-152">
                dopaminado las 24 horas del día
              </span>
              . Aprendí a elevar mi mentalidad y la uso a mi favor.{' '}
              <span className="text-white font-semibold" data-id="element-153">
                Hoy te enseño lo que construí
              </span>{' '}
              — la disciplina para escalar cualquier sueño o meta que tengas,
              sea conseguir dinero o hacerte profesional en alguna habilidad.
            </p>

            {/* Credential cards */}
            <div className="flex flex-col gap-4 mt-2" data-id="element-154">
              {credentials.map((c, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2 + i * 0.1
            }} className="flex items-start gap-4 p-4 bg-[#111] border border-white/5 rounded-sm" data-id="element-155">
                  <span className="text-2xl shrink-0 mt-0.5" data-id="element-156">{c.icon}</span>
                  <div data-id="element-157">
                    <p className="text-white font-semibold text-sm mb-1" data-id="element-158">
                      {c.title}
                    </p>
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-159">
                      {c.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}